import { ComboBoxDoubleLineOption } from '../../../cdl/ComboBox/ComboBox';
import type { ComboBoxOptionComponentProps } from '../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Text } from '../../../cdl/Text/Text';
import { AgentImportedLabel } from '../../../common/AgentImportedLabel/AgentImportedLabel';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { Box } from '../../../common/ui/Box';
import type { AgentSelectOption } from '../AgentSelectOption';

export const AgentOption = ({ option }: ComboBoxOptionComponentProps<AgentSelectOption>) => {
    if (!option.agent) {
        return (
            <Box display="flex" alignItems="center" gap={4} color="accent.foreground" height={40}>
                <IconPlus width={16} height={16} />
                <Text variant="small" fontWeight={500}>
                    {translate('selectAgent.createAgent')}
                </Text>
            </Box>
        );
    }

    const { contact } = option.agent;
    const contactDetails = [
        contact?.emailAddress ? `${translate('global.contact.email')}: ${contact.emailAddress}` : null,
        contact?.phoneNumber ? `${translate('global.contact.phone')}: ${contact.phoneNumber}` : null,
    ]
        .filter(Boolean)
        .join(', ');

    if (contactDetails) {
        return (
            <ComboBoxDoubleLineOption
                title={option.label}
                description={contactDetails}
                trailingVisual={option.agent.source ? <AgentImportedLabel /> : null}
            />
        );
    }

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={8}
            height={40}
            minWidth={0}
            overflow="hidden"
        >
            <Text
                display="block"
                variant="small"
                fontWeight={500}
                style={{
                    flexShrink: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {option.label}
            </Text>
            {option.agent.source ? (
                <Box flexShrink={0}>
                    <AgentImportedLabel />
                </Box>
            ) : null}
        </Box>
    );
};
